import { Component, OnInit } from '@angular/core';
import { FormService } from '../services/form.service';
import { ApiService } from "../services/api.service";
import { animate, style, transition, trigger } from "@angular/animations";
import { environment } from "../../environments/environment";

@Component( {
	selector: 'app-post-submit',
	templateUrl: './post-submit.component.html',
	styleUrls: ['./post-submit.component.scss'],
	animations: [
		trigger('slideInOut', [
			transition(':enter', [
				style({ opacity: 0, position: 'absolute', width: '100%' }),
				animate('300ms ease-in-out', style({ opacity: 1 }))
			]),
			transition(':leave', [
				style({ opacity: 1, position: 'absolute', width: '100%' }),
				animate('300ms ease-in-out', style({ opacity: 0 }))
			]),
		])
	]
} )
export class PostSubmitComponent implements OnInit {

	private debugQuestions : boolean = false;
	private debugCountDownAndRedirect : boolean = false;

	constructor( public formService: FormService,
	             private apiService: ApiService ) {

	}

	ngOnInit(): void {

		// == Debugging questions ==
		if( this.debugQuestions && ! environment.production ) {

			this.apiService.getTestQuestions().subscribe( response => {

				this.formService.questions = Object.values( JSON.parse( response ) );
				this.formService.setupThirdPartyForm();
				this.formService.postSubmitStep = 'thirdPartyQuestions';
			} );
		}

		if( this.debugCountDownAndRedirect && ! environment.production ) {

			// This requires formService.formActive to be on false as well
			// This does not work together with the third party questions
			setTimeout( () => {

				this.formService.token = 'testing';
				this.formService.countDownAndRedirect();
			}, 1000 );
		}

		// == END DEBUGGING == //
	}
}
